<template>
  <v-container>
    <v-row>
      <v-col>
        <h1 class="mb-4">Certifications</h1>
      </v-col>
    </v-row>
    <v-row>
      <v-col
        cols="6"
        sm="4"
        v-for="(item, index) in certifications"
        :key="index"
        class="d-flex justify-center"
      >
        <CertificationComponent
          :url="item.url"
          :image="item.image"
          :from="item.from"
          :to="item.to"
        />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import CertificationComponent from "@/components/sub-components/CertificationComponent.vue";
export default {
  name: "Certifications",
  data() {
    return {
      certifications: [
        {
          url: "https://www.credly.com/badges/7cabc9f2-20e8-4cbe-bd82-a55cd18b4e60",
          image:
            "https://personal-website-assets104410-dev.s3.amazonaws.com/certifications/solutions-arch-pro.png",
          from: "September 2022",
          to: "September 2025",
        },
        {
          url: "https://www.certmetrics.com/amazon/public/badge.aspx?i=2&t=c&d=2018-08-24&ci=AWS00598249",
          image:
            "https://personal-website-assets104410-dev.s3.amazonaws.com/certifications/developer.png",
          from: "August 2018",
          to: "August 2021",
        },
        {
          url: "https://www.certmetrics.com/amazon/public/badge.aspx?i=1&t=c&d=2018-09-28&ci=AWS00598249",
          image:
            "https://personal-website-assets104410-dev.s3.amazonaws.com/certifications/solutions-arch.png",
          from: "September 2018",
          to: "September 2021",
        },
        {
          url: "https://www.certmetrics.com/amazon/public/badge.aspx?i=3&t=c&d=2018-10-26&ci=AWS00598249",
          image:
            "https://personal-website-assets104410-dev.s3.amazonaws.com/certifications/sysops.png",
          from: "October 2018",
          to: "October 2021",
        },
      ],
    };
  },
  components: {
    CertificationComponent,
  },
};
</script>

<style>
</style>